import {Box, IconButton, Modal, Stack, Typography} from "@mui/material";
import {Close} from "@mui/icons-material"
import React from "react";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: "280px",
  maxWidth: "100dvw",
  width: {xs: "100vw", md: "60%"},
  maxHeight: "100vh",
  height: {xs: "100vh", md: "90%"},
  bgcolor: 'background.paper',
  borderRadius: 0,
  border: '0px solid #000',
  boxShadow: 24,
  p: 3,
  overflowY: "auto"
};

export const DebugMessageModal = ({open, handleClose, debugMessage}) => {

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Stack direction={"column"} gap={2} sx={style}>
        <Stack direction={"row"} gap={2} justifyContent={"space-between"} alignItems={"center"}>
          <Typography fontSize={"1.2rem"} fontWeight={600}>Debug Message</Typography>
          <Box>
            <IconButton onClick={handleClose}>
              <Close />
            </IconButton>
          </Box>
        </Stack>
        <Stack sx={{flex: 1, overflowY: "auto"}}>
          <Typography >
            <Typography fontSize={12} sx={{borderLeft: 2, borderColor: "divider", pl: 1}}>{debugMessage?.text}</Typography>
          </Typography>
        </Stack>
      </Stack>
    </Modal>
  )
}